import { withInstall } from '../../utils/install';
import DatePicker from './src/date-picker.vue';

export const IDatePicker = withInstall(DatePicker); // 增加类型

export default IDatePicker;
